import { createTheme, Theme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface CustomColor {
    [key: string]: string;
  }

  interface Palette {
    blue: CustomColor;
    green: CustomColor;
    red: CustomColor;
    yellow: CustomColor;
    customGrey: CustomColor;
  }

  interface PaletteOptions {
    blue: CustomColor;
    green: CustomColor;
    red: CustomColor;
    yellow: CustomColor;
    customGrey: CustomColor;
  }

  interface TypographyVariants {
    bodyM?: React.CSSProperties;
    bodyL?: React.CSSProperties;
    bodyS?: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    bodyM?: React.CSSProperties;
    bodyL?: React.CSSProperties;
    bodyS?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    bodyM: true;
    bodyL: true;
    bodyS: true;
  }
}

const currentLang = localStorage.getItem("i18nextLng") || "en";
const ifRtl = currentLang !== "en";

const theme: Theme = createTheme({
  palette: {
    common: {
      black: "#323232",
    },
    primary: {
      main: "#87CCFB",
      dark: "#54B8F9",
      light: "#A3D9FC",
    },
    blue: {
      main: "#74B0D7",
      light: "#E3EFF7",
    },
    green: {
      main: "#62CBA5",
      light: "#D4FEED",
    },
    red: {
      main: "#DC787B",
      light: "#F3DCDB",
    },
    yellow: {
      main: "#EAB65A",
      light: "#FDF5E7",
    },
    customGrey: {
      main: "#A4B2C7",
      dark: "#525A6A",
      pure: "#EAEEF4",
      soft: "#F8F9FC",
    },
  },
  typography: {
    fontFamily: ["Outfit", "sans-serif"].join(","),
    h1: {
      fontSize: "32px",
      fontWeight: 500,
      lineHeight: "120%",
      "@media (min-width:768px)": {
        fontSize: "40px",
      },
    },
    h2: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "150%",
    },
    h3: {
      fontSize: "18px",
      fontWeight: 500,
      lineHeight: "150%",
    },
    bodyL: {
      fontFamily: ["Outfit", "sans-serif"].join(","),
      fontSize: "16px",
      lineHeight: "150%",
    },
    bodyM: {
      fontFamily: ["Outfit", "sans-serif"].join(","),
      fontSize: "14px",
      lineHeight: "150%",
    },
    bodyS: {
      fontFamily: ["Outfit", "sans-serif"].join(","),
      fontSize: "12px",
      lineHeight: "150%",
    },
  },
  direction: ifRtl ? "rtl" : "ltr",
});

export default theme;
